<script lang="ts">
  let clazz = '';
  export { clazz as class };
</script>

<span class={clazz}>&#9679;</span>
